import React from "react";
import { H4, Body } from "@irati/ui/src/Typography";
import Spacing from "@irati/ui/src/Spacing";
import { StyledSignUpOption } from "./styled";
var SignUpOption = function (_a) {
    var _b = _a.active, active = _b === void 0 ? false : _b, onClick = _a.onClick, title = _a.title, description = _a.description, children = _a.children;
    return (React.createElement(StyledSignUpOption, { active: active, onClick: onClick },
        React.createElement(H4, { marginBottom: 1 }, title),
        React.createElement(Body, null, description),
        active && React.createElement(Spacing, { marginTop: 3 }, children)));
};
export default SignUpOption;
